import { useTheme } from '@mui/material/styles';

const LogoIcon = () => {
  const theme = useTheme();

  return (
    <svg
      style={{ width: 'auto', height: 22 }}
      viewBox="0 0 80 10"
      width="80"
      height="10"
    >
      <path
        fill={theme.palette.primary.main}
        d="M 2.652 5.328 C 3.12 5.944 3.68 6.533 4.239 7.094 C 5.212 8.071 6.318 8.953 7.439 9.623 L 4.159 9.623 C 2.466 8.392 0.988 6.747 0 5.101 C 0.973 3.483 2.466 1.838 4.159 0.607 L 7.439 0.607 C 6.318 1.289 5.212 2.158 4.239 3.135 C 3.68 3.697 3.12 4.312 2.652 4.901 C 2.6 4.954 2.573 5.021 2.573 5.101 C 2.573 5.209 2.6 5.289 2.652 5.328 M 19.197 5.328 C 18.729 5.944 18.17 6.533 17.61 7.094 C 16.637 8.071 15.53 8.953 14.41 9.623 L 17.69 9.623 C 19.384 8.392 20.863 6.747 21.849 5.101 C 20.877 3.457 19.384 1.811 17.69 0.58 L 14.41 0.58 C 15.53 1.289 16.637 2.145 17.61 3.135 C 18.17 3.697 18.729 4.312 19.197 4.901 C 19.25 4.954 19.277 5.021 19.277 5.101 C 19.277 5.209 19.25 5.289 19.197 5.328 M 10.919 7.068 C 11.998 7.068 12.851 6.212 12.851 5.128 C 12.851 4.045 11.998 3.188 10.919 3.188 C 9.838 3.188 8.985 4.045 8.985 5.128 C 9.012 6.184 9.866 7.068 10.919 7.068 M 10.919 0.62 C 13.411 0.62 15.425 2.626 15.425 5.142 C 15.425 7.656 13.425 9.662 10.919 9.662 C 8.412 9.662 6.413 7.656 6.413 5.142 C 6.439 2.626 8.439 0.62 10.919 0.62"
        origin="0 0.053706"
      />
    </svg>
  );
};

export default LogoIcon;
